<app-page-title [title]="'Affiliate Report'"></app-page-title>
<div class="row">
    <div class="col-md-12"> Please select a date range</div>
</div>
<form
    [formGroup]="userForm"
    name="affiliate-report-form"
>
    <div class="row">
        <div class="col-md-4">
            <div class="form-group">
                <label>Date From <em>*</em></label>
                <input
                    type="date"
                    class="form-control"
                    formControlName="dateFrom"
                    placeholder="Click to select"
                    (change)=updateRequest();
                    name="dateFrom"
                />
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group">
                <label>Date To <em>*</em></label>
                <input
                    type="date"
                    class="form-control"
                    formControlName="dateTo"
                    placeholder="Click to select"
                    (change)=updateRequest();
                    name="dateTo"
                />
            </div>
        </div>
        <div class="col-md-1">
            <button
                type="button"
                class="btn btn-primary date-select-btn"
                name="getReportBtn"
                (click)="getReport(request)"
            >Go</button>
        </div>
        <br /><br />
        <div class="col-md-3">
            <button
                class="btn btn-primary date-select-btn"
                name="getCurrentPayPeriodBtn"
                type="submit"
                (click)="getCurrentPayPeriod()"
            >View Current Pay Period</button>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12"> <em>*</em> Please Note: 3 months for each pay period </div>
    </div>
    <br>
    <div class="row">
        <div class="col-md-12">
            <em>*</em> Please note, affiliate activity may not be reflected immediately. The "number of purchases" counts completed test sittings as at today's date,
            therefore, if test takers are registered for future tests dates, those numbers will appear following the day of the test.
            If you have any questions please contact <a href="mailto:memberteam@prometric.com">memberteam@prometric.com</a> for support.
        </div>
    </div>

    <br />
    <div class="row reviewOrder">

        <div class="col-md-12">
            <table class="affiliate">
                <tr>
                    <th style="max-width:50%;text-align:left">Link</th>
                    <th>Delivery Method</th>
                    <th># of Clicks</th>
                    <th># of Accounts</th>
                    <th># of Purchases</th>
                    <th># Purchases without Payout</th>
                    <th>Currency</th>
                    <th>Total Purchases</th>
                    <th>Payout</th>
                </tr>
                <tr *ngIf="summaryData.length == 0 || summaryData == null || summaryData == undefined ">
                    <td colspan="9">There are no current records</td>
                </tr>
                <ng-container *ngFor="let affiliateLinkSummary of summaryData">
                    <tr>
                        <td style="width:40%; text-align:left">
                            <a
                                [routerLink]="['/account/affiliate/link-detail']"
                                [queryParams]="{linkId: affiliateLinkSummary.id}"
                                style="font-size:14px;"
                            >{{affiliateLinkSummary.linkName}}</a></td>
                        <td>{{affiliateLinkSummary.deliveryMethod}}</td>
                        <td>{{affiliateLinkSummary.clicks}}</td>
                        <td>{{affiliateLinkSummary.accounts}}</td>
                        <td>{{affiliateLinkSummary.purchases}}</td>
                        <td>{{affiliateLinkSummary.purchasesNumberWithoutPayment}}</td>
                        <td>
                            <div *ngFor="let purchaseSummary of affiliateLinkSummary.currencyDetail">
                                <div>{{purchaseSummary.currency}}</div>
                            </div>
                        </td>
                        <td>
                            <div *ngFor="let purchaseSummary of affiliateLinkSummary.currencyDetail">
                                <div>{{purchaseSummary.purchaseAmount | currency : "" :""}}</div>
                            </div>
                        </td>
                        <td>
                            <div *ngFor="let purchaseSummary of affiliateLinkSummary.currencyDetail">
                                <div>{{purchaseSummary.payout | currency : "" : ""}}</div>
                            </div>
                        </td>
                    </tr>
                </ng-container>
            </table>
        </div>
    </div>
    <br />
    <button
        type="button"
        class="btn btn-primary"
        [routerLink]="['/account/affiliate/dashboard']"
    >Back</button>
</form>
